// extracted by mini-css-extract-plugin
export default {"unauthorizedMessage":"Unauthorized_unauthorizedMessage__pyXcc"};